import { useState, useEffect } from 'react';

/**
 * Misma lógica que BracketGame para width/height: debe coincidir con gameDimensions del SVG padre.
 */
export function getBracketCardDimensions(viewportWidth) {
  const w = viewportWidth ?? 1200;
  const isTinyMobile = w <= 360;
  const isSmallMobile = w <= 480;
  const isMobile = w <= 600;
  return {
    isTinyMobile,
    isSmallMobile,
    isMobile,
    gameWidth: isTinyMobile ? 210 : isSmallMobile ? 232 : isMobile ? 252 : 308,
    gameHeight: isTinyMobile ? 108 : isSmallMobile ? 122 : isMobile ? 134 : 188,
  };
}

export function useBracketLayout() {
  const [layout, setLayout] = useState(() =>
    typeof window !== 'undefined'
      ? getBracketCardDimensions(window.innerWidth)
      : getBracketCardDimensions(1200)
  );

  useEffect(() => {
    const onResize = () => setLayout(getBracketCardDimensions(window.innerWidth));
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return layout;
}
